import { inject, Injectable } from '@angular/core';

import { RestService } from './rest-service';
import { Observable } from 'rxjs';
import { UserSubscriptionResponse } from '@hunting-nature/shared-core/interfaces/user-subscription-response.interface';
import { UserCreditsResponse } from '@hunting-nature/shared-core/interfaces/user-credits-response.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  // services
  private readonly restService = inject(RestService);

  public getSubscriptionDetails$(): Observable<UserSubscriptionResponse> {
    return this.restService.fetchSubscriptionDetails$();
  }

  public getPrepaidCreditsDetails$(): Observable<UserCreditsResponse> {
    return this.restService.fetchPrepaidCreditsDetails$();
  }
}
